export const ACWD_EMAIL = ["water.cons@acwd.com"];
export const EMAIL_FROM_NAME = "ACWD Water Savings Center";
